import { Id, Snakify } from "PFTypes";

type ItemWithId = Snakify<{
  id?: Id | null;
  globalId?: Id | null;
}>;

// eslint-disable-next-line camelcase
export const getId = ({ id, globalId, global_id }: ItemWithId): Id => id ?? globalId ?? global_id ?? "";
